import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-16 pb-20 px-4 overflow-hidden" data-id="element-170">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center lg:items-start text-center lg:text-left z-10" data-id="element-172">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-4 text-balance" data-id="element-173">
            Merezco la Vida de Mis Sueños
          </h1>

          <p className="font-script text-3xl md:text-4xl text-brand-rose mb-8" data-id="element-174">
            La Abu Aurora
          </p>

          <div className="space-y-4 text-lg md:text-xl text-brand-textLight mb-10 max-w-xl" data-id="element-175">
            <p className="font-medium text-brand-plum" data-id="element-176">
              Tu Mente Tiene el Poder de Crear la Vida que Deseas.
            </p>
            <p data-id="element-177">Solo Nadie Te Enseñó Cómo Usarla.</p>
            <p data-id="element-178">
              Descubre el método ancestral de "La Abu Aurora" para activar tu
              Subconsciente Fértil y atraer prosperidad, amor y abundancia real
              — empezando hoy mismo.
            </p>
          </div>

          <div className="flex items-center gap-2 text-brand-plum font-medium mb-8 bg-white/50 py-3 px-5 rounded-xl border border-brand-gold/20" data-id="element-179">
            <span className="text-xl" data-id="element-180">✨</span>
            <p data-id="element-181">
              Miles de personas ya despertaron su poder interior con este
              método. Ahora es tu turno.
            </p>
          </div>

          <CTAButton text="¡SÍ, QUIERO ACTIVAR MI SUBCONSCIENTE FÉRTIL AHORA!" data-id="element-182" />

          <p className="mt-6 text-center lg:text-left w-full text-brand-plum font-semibold text-lg" data-id="element-183">
            Acceso inmediato a Merezco la Vida de Mis Sueños por solo{' '}
            <span className="text-brand-rose text-2xl font-bold" data-id="element-184">$14 USD</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative z-10 flex justify-center" data-id="element-185">
          <div className="relative w-full max-w-md aspect-[4/5]" data-id="element-186">
            <div className="absolute inset-0 bg-brand-gold/20 rounded-3xl transform rotate-3 scale-105 blur-xl" data-id="element-187"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qZqH9Pk8uBrm6esCAGHjhe/ChatGPT_Image_5_may_2026,_01_36_16_a.m..png" alt="Merezco la Vida de Mis Sueños Libro" className="relative z-10 w-full h-full object-cover rounded-2xl shadow-2xl border border-white/20" data-id="element-188" />
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-bgAlt to-transparent -z-10" data-id="element-189"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-rose/5 rounded-full blur-3xl -z-10" data-id="element-190"></div>
      <div className="absolute top-40 -left-20 w-72 h-72 bg-brand-gold/10 rounded-full blur-3xl -z-10" data-id="element-191"></div>
    </section>;
}